export default __webpack_public_path__ + "static/media/p14.942742ef.jpg";